import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1c6ffbdb"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _createTextVNode("男");
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("女");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("是");
var _hoisted_12 = /*#__PURE__*/ _createTextVNode("否");
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "报告接收信息", -1); });
import { useRouter } from "vue-router";
import { Form, Field, RadioGroup, Radio } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'patientInfo',
    props: {
        patientInfo: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var router = useRouter();
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Form), null, {
                        default: _withCtx(function () {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                            return [
                                _createVNode(_unref(Field), {
                                    "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.patientName,
                                    label: "患者姓名",
                                    placeholder: "请输入患者姓名"
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), { label: "性别" }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.patientGender,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: 1
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_3
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: 0
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_4
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    "model-value": (_b = props.patientInfo) === null || _b === void 0 ? void 0 : _b.patientAge,
                                    label: "年龄",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_c = props.patientInfo) === null || _c === void 0 ? void 0 : _c.clinicalDiagnosis,
                                    label: "临床诊断",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_d = props.patientInfo) === null || _d === void 0 ? void 0 : _d.diseaseStage,
                                    label: "疾病分期",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_e = props.patientInfo) === null || _e === void 0 ? void 0 : _e.medicationHistory,
                                    label: "用药史",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_f = props.patientInfo) === null || _f === void 0 ? void 0 : _f.familyMedicalHistory,
                                    label: "病史",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    label: "6个月内异体输血",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.allogeneicTransfusion,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_5
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_6
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    label: "器官移植",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.organTransplant,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_7
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_8
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    label: "干细胞移植",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.stemCellTransplant,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_9
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_10
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    label: "传染性疾病",
                                    "label-width": "8em"
                                }, {
                                    input: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createVNode(_unref(RadioGroup), {
                                                "model-value": (_a = props.patientInfo) === null || _a === void 0 ? void 0 : _a.infectiousDisease,
                                                direction: "horizontal"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: true
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_11
                                                        ]; }),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(Radio), {
                                                        "checked-color": "#3DABA4",
                                                        name: false
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_12
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["model-value"])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_unref(Field), {
                                    "model-value": (_g = props.patientInfo) === null || _g === void 0 ? void 0 : _g.previousTreatmentRegimen,
                                    rows: "2",
                                    autosize: "",
                                    label: "既往治疗方案",
                                    type: "textarea",
                                    maxlength: "40",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_h = props.patientInfo) === null || _h === void 0 ? void 0 : _h.formulateTreatmentPlan,
                                    rows: "2",
                                    autosize: "",
                                    label: "拟定治疗方案",
                                    type: "textarea",
                                    maxlength: "40",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _hoisted_13,
                                _createVNode(_unref(Field), {
                                    "model-value": (_j = props.patientInfo) === null || _j === void 0 ? void 0 : _j.reportReceivingAddress,
                                    label: "接收地址",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_k = props.patientInfo) === null || _k === void 0 ? void 0 : _k.reportReceivingEmail,
                                    label: "接收邮箱",
                                    readonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_l = props.patientInfo) === null || _l === void 0 ? void 0 : _l.reportReceiver,
                                    label: "接收人",
                                    preadonly: ""
                                }, null, 8, ["model-value"]),
                                _createVNode(_unref(Field), {
                                    "model-value": (_m = props.patientInfo) === null || _m === void 0 ? void 0 : _m.reportReceiverMobile,
                                    label: "联系电话",
                                    readonly: ""
                                }, null, 8, ["model-value"])
                            ];
                        }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
